export default __webpack_public_path__ + "static/media/user.ed4256bb.svg";